export default __webpack_public_path__ + "static/4-cf3c65e2021a071f31014c2d68844f8a.svg";